import {
  type ClassroomAssignedModuleEntity,
  ClassroomAssignedModuleSchema
} from '@/core/infrastructure/schemas/school/assignment/AssignmentSchema.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'


export class ClassroomAssignedModule {
  readonly id: number
  readonly schoolAssignedModuleId: number
  readonly classroomId: number
  readonly order: number
  readonly visible: boolean
  readonly visibleAt: string | null

  constructor(input: ClassroomAssignedModuleEntity) {
    this.id = input.id
    this.schoolAssignedModuleId = input.schoolAssignedModuleId
    this.classroomId = input.classroomId
    this.order = input.order
    this.visible = input.visible
    this.visibleAt = input.visibleAt
  }

  /**
   * Méthode de création statique qui valide les données avant instanciation
   */
  public static create(data: unknown): ClassroomAssignedModule {
    return EntityValidator.validateAndCreate(ClassroomAssignedModuleSchema, data, ClassroomAssignedModule, 'ClassroomAssignedModule')
  }
}